<template>
  <div class="row">
    <div class="col s12">
      <div class="card core-card">
        <div class="card-content">
          <span class="card-title">Create New Request</span>

          <div class="core-inline venue-context-line">
            <span class="grey-text text-darken-1">Venue:</span>
            <strong>{{ venueName }}</strong>
          </div>

          <div class="row">
            <div class="input-field col s12 m6">
              <input
                id="request-title"
                :value="title"
                type="text"
                :disabled="saving || disabled"
                @input="$emit('update:title', $event.target.value)"
              />

              <label for="request-title" :class="{ active: title }">
                Request title
              </label>
            </div>

            <div class="input-field col s12 m6">
              <input
                id="request-due-date"
                :value="dueDate"
                type="date"
                :disabled="saving || disabled"
                @input="$emit('update:dueDate', $event.target.value)"
              />

              <label for="request-due-date" class="active"> Required by </label>
            </div>

            <div class="input-field col s12">
              <textarea
                id="request-notes"
                :value="notes"
                class="materialize-textarea"
                :disabled="saving || disabled"
                @input="$emit('update:notes', $event.target.value)"
              ></textarea>

              <label for="request-notes" :class="{ active: notes }">
                Request details
              </label>
            </div>
          </div>

          <button
            class="btn green darken-2"
            type="button"
            :disabled="saving || disabled || !title.trim()"
            @click="$emit('create')"
          >
            {{ saving ? "Creating..." : "Create Request" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ArtworkRequestForm",

  props: {
    title: {
      type: String,
      default: "",
    },

    notes: {
      type: String,
      default: "",
    },

    dueDate: {
      type: String,
      default: "",
    },

    venueName: {
      type: String,
      default: "Not selected",
    },

    saving: {
      type: Boolean,
      default: false,
    },

    disabled: {
      type: Boolean,
      default: false,
    },
  },

  emits: ["update:title", "update:notes", "update:dueDate", "create"],
};
</script>

<style scoped>
.venue-context-line {
  margin: 8px 0 18px;
}
</style>
